import PageTitle from "../../Components/UIcomponents/PageTitle";
import AboutBtcl from "./components/AboutBtcl";
import Constitution from "./components/Constitution";
import Discipline from "./components/Discipline";
import Committee from "./components/Committee";
import PlayingConditions from "./components/PlayingConditions";
import AccountingSection from "./components/AccountingSection";

import axios from "axios";
import { API_BASE_URL } from "../../apiConfig";
import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';

function WhoWeAre() {
    const [about, setAbout] = useState('');
    const [constitution, setConstitution] = useState('');
    const [discipline, setDiscipline] = useState('');
    const [playingCondition, setPlayingCondition] = useState('');
    const [accounting, setAccounting] = useState('');

    const urls = useParams()
    useEffect(() => {
        const language = document.getElementById('language').value;
        if (urls.id == 1) {
            let i, tabcontent, tablinks;
            tabcontent = document.getElementsByClassName("tabcontent");
            for (i = 0; i < tabcontent.length; i++) {
                tabcontent[i].style.display = "none";
            }
            tablinks = document.getElementsByClassName("tablinks");
            for (i = 0; i < tablinks.length; i++) {
                tablinks[i].className = tablinks[i].className.replace(" active", "");
            }
            document.getElementById('PlayingConditions').style.display = "block";
            document.getElementById('playigConditionLink').className += " active";
        }
        axios.get(`${API_BASE_URL}/about/${language}`).then((res) => {
            const about = res.data.about;
            setAbout(about.about_btcl);
            setConstitution(about.constitution);
            setDiscipline(about.discipline)
            setPlayingCondition(about.playing_condition);
            setAccounting(about.accounting);

        });
    }, []);

    const mobileScreen = 600;
    const desktopScreen = 1200;

    const styles = {
        tab: {
            maxWidth: 'var(--maxWidth)',
            margin: '',
            boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.25)',
            borderRadius: '0px'
            
        },
        tabBtnWrapper: {
            height: 'auto', // Allow dynamic height
            display: 'flex', // Use flexbox for alignment
            justifyContent: 'space-between', // Distribute buttons evenly
            flexWrap: 'wrap', // Handle overflow gracefully
            marginBottom: '2rem',
            rowGap: '.5rem', // Add spacing between rows if wrapping occurs
            columnGap: '1rem' // Add spacing between buttons
        },
        Btn: {
            background: 'white',
            border: '1px solid var(--colorPrimary)',
            font: '800 16px var(--fontInter)',
            cursor: 'pointer',
            padding: '1rem 1rem', // Add padding for better spacing
            flex: '1 1 auto', // Allow buttons to adjust their size
            textAlign: 'center' // Center-align text
        },
        Btnpc: {
            background: 'white',
            border: '1px solid var(--colorPrimary)',
            font: '800 16px var(--fontInter)',
            cursor: 'pointer',
            padding: '0.5rem 1rem',
            flex: '1 1 auto',
            textAlign: 'center'
        },
        visionPointsWrapper: {
            display: 'flex',
        },
        visionPointsNo: {
            marginRight: '2rem'
        }
    };

    if (window.innerWidth <= mobileScreen) {
        styles.Btn.font = '800 16px var(--fontInter)';
        styles.Btn.marginBottom = '5px';

        styles.Btn.width = '100%';

        styles.tabBtnWrapper.marginBottom = '30px';
    }
   



    

    function openTab(e, id) {
        let i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("tabcontent");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }
        tablinks = document.getElementsByClassName("tablinks");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }
        document.getElementById(id).style.display = "block";
        e.currentTarget.className += " active";
        if (window.innerWidth <= mobileScreen) {
            window.scrollTo({
                top: e.currentTarget.offsetTop + 30, // Adjust the scroll position
                behavior: 'smooth', // Smooth scrolling
            });
        }
    }
    return (
        <div>
            <PageTitle name='WHO WE ARE ?' />
            <div style={{ margin: '2rem auto', maxWidth: 'var(--maxWidth)' }}>
                <div id="WhoweareTab" style={styles.tab}>
                    <div id="who-area-btn-wrapper" style={styles.tabBtnWrapper}>
                        <button className="tablinks active" style={styles.Btn} onClick={(e) => openTab(e, 'About-Btcl')}>ABOUT BTCL</button>

                        <button className="tablinks" style={styles.Btn} onClick={(e) => openTab(e, 'Constitution')}>CONSTITUTION</button>

                        <button id="playigConditionLink" className="tablinks" style={styles.Btnpc} onClick={(e) => openTab(e, 'PlayingConditions')}>PLAYING CONDITIONS</button>

                        <button className="tablinks" style={styles.Btn} onClick={(e) => openTab(e, 'Discipline')}>DISCIPLINE</button>

                        <button className="tablinks" style={styles.Btn} onClick={(e) => openTab(e, 'Committee')}>COMMITTEE</button>

                        <button id="accountingsection" className="tablinks" style={styles.Btn} onClick={(e) => openTab(e, 'Accountingsection')}>ACCOUNTING</button>
                    </div>

                    <AboutBtcl data={about} />
                    <Constitution data={constitution} />
                    <Discipline data={discipline} />
                    <PlayingConditions  />
                    <AccountingSection  />
                    <Committee />
                </div>
            </div>
        </div>
    );
}

export default WhoWeAre;